import React, { PropsWithChildren, ReactNode } from "react";
import styled from "styled-components";
import { EffectFade, Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { prop } from "styled-tools";
import { Box, BoxProps } from "../box/Box";

const Container = styled(Box)`
    @font-face {
        font-family: 'swiper-icons';
        src: url('data:application/font-woff;charset=utf-8;base64, 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');
        font-weight: 400;
        font-style: normal;
    }
    /* FONT_END */
    
        --swiper-theme-color: black;
        /*
        --swiper-preloader-color: var(--swiper-theme-color);
        --swiper-wrapper-transition-timing-function: initial;
        */
        
        --swiper-pagination-color: ${prop('paginationColor', "black")};
        //--swiper-pagination-left: auto;
        //--swiper-pagination-right: 8px;
        //--swiper-pagination-bottom: 8px;
        //--swiper-pagination-top: auto;
        //--swiper-pagination-fraction-color: inherit;
        //--swiper-pagination-progressbar-bg-color: rgba(0,0,0,0.25);
        //--swiper-pagination-progressbar-size: 4px;
        //--swiper-pagination-bullet-size: 8px;
        //--swiper-pagination-bullet-width: 8px;
        //--swiper-pagination-bullet-height: 8px;
        //--swiper-pagination-bullet-border-radius: 50%;
        //--swiper-pagination-bullet-inactive-color: #000;
        //--swiper-pagination-bullet-inactive-opacity: 0.2;
        //--swiper-pagination-bullet-opacity: 1;
        //--swiper-pagination-bullet-horizontal-gap: 4px;
        //--swiper-pagination-bullet-vertical-gap: 6px;
    
    :host {
        position: relative;
        display: block;
        margin-left: auto;
        margin-right: auto;
        z-index: 1;
    }
    .swiper {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        /* Fix of Webkit flickering */
        z-index: 1;
        display: block;
    }
    .swiper-vertical > .swiper-wrapper {
        flex-direction: column;
    }
    .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: flex;
        transition-property: transform;
        transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);
        box-sizing: content-box;
    }
    .swiper-android .swiper-slide,
    .swiper-ios .swiper-slide,
    .swiper-wrapper {
        transform: translate3d(0px, 0, 0);
    }
    .swiper-horizontal {
        touch-action: pan-y;
    }
    .swiper-vertical {
        touch-action: pan-x;
    }
    .swiper-slide {
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
        transition-property: transform;
        display: block;
    }
    .swiper-slide-invisible-blank {
        visibility: hidden;
    }
    /* Auto Height */
    .swiper-autoheight,
    .swiper-autoheight .swiper-slide {
        height: auto;
    }
    .swiper-autoheight .swiper-wrapper {
        align-items: flex-start;
        transition-property: transform, height;
    }
    .swiper-backface-hidden .swiper-slide {
        transform: translateZ(0);
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }
    /* 3D Effects */
    .swiper-3d.swiper-css-mode .swiper-wrapper {
        perspective: 1200px;
    }
    .swiper-3d .swiper-wrapper {
        transform-style: preserve-3d;
    }
    .swiper-3d {
        perspective: 1200px;
    }
    .swiper-3d .swiper-slide,
    .swiper-3d .swiper-cube-shadow {
        transform-style: preserve-3d;
    }
    /* CSS Mode */
    .swiper-css-mode > .swiper-wrapper {
        overflow: auto;
        scrollbar-width: none;
        /* For Firefox */
        -ms-overflow-style: none;
        /* For Internet Explorer and Edge */
    }
    .swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {
        display: none;
    }
    .swiper-css-mode > .swiper-wrapper > .swiper-slide {
        scroll-snap-align: start start;
    }
    .swiper-css-mode.swiper-horizontal > .swiper-wrapper {
        scroll-snap-type: x mandatory;
    }
    .swiper-css-mode.swiper-vertical > .swiper-wrapper {
        scroll-snap-type: y mandatory;
    }
    .swiper-css-mode.swiper-free-mode > .swiper-wrapper {
        scroll-snap-type: none;
    }
    .swiper-css-mode.swiper-free-mode > .swiper-wrapper > .swiper-slide {
        scroll-snap-align: none;
    }
    .swiper-css-mode.swiper-centered > .swiper-wrapper::before {
        content: '';
        flex-shrink: 0;
        order: 9999;
    }
    .swiper-css-mode.swiper-centered > .swiper-wrapper > .swiper-slide {
        scroll-snap-align: center center;
        scroll-snap-stop: always;
    }
    .swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {
        margin-inline-start: var(--swiper-centered-offset-before);
    }
    .swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper::before {
        height: 100%;
        min-height: 1px;
        width: var(--swiper-centered-offset-after);
    }
    .swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {
        margin-block-start: var(--swiper-centered-offset-before);
    }
    .swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper::before {
        width: 100%;
        min-width: 1px;
        height: var(--swiper-centered-offset-after);
    }
    /* Slide styles start */
    /* 3D Shadows */
    .swiper-3d .swiper-slide-shadow,
    .swiper-3d .swiper-slide-shadow-left,
    .swiper-3d .swiper-slide-shadow-right,
    .swiper-3d .swiper-slide-shadow-top,
    .swiper-3d .swiper-slide-shadow-bottom,
    .swiper-3d .swiper-slide-shadow,
    .swiper-3d .swiper-slide-shadow-left,
    .swiper-3d .swiper-slide-shadow-right,
    .swiper-3d .swiper-slide-shadow-top,
    .swiper-3d .swiper-slide-shadow-bottom {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 10;
    }
    .swiper-3d .swiper-slide-shadow {
        background: rgba(0, 0, 0, 0.15);
    }
    .swiper-3d .swiper-slide-shadow-left {
        background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    }
    .swiper-3d .swiper-slide-shadow-right {
        background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    }
    .swiper-3d .swiper-slide-shadow-top {
        background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    }
    .swiper-3d .swiper-slide-shadow-bottom {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    }
    .swiper-lazy-preloader {
        width: 42px;
        height: 42px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -21px;
        margin-top: -21px;
        z-index: 10;
        transform-origin: 50%;
        box-sizing: border-box;
        border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));
        border-radius: 50%;
        border-top-color: transparent;
    }
    .swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,
    .swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader {
        animation: swiper-preloader-spin 1s infinite linear;
    }
    .swiper-lazy-preloader-white {
        --swiper-preloader-color: #fff;
    }
    .swiper-lazy-preloader-black {
        --swiper-preloader-color: #000;
    }
    @keyframes swiper-preloader-spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .swiper-fade.swiper-free-mode .swiper-slide {
        transition-timing-function: ease-out;
    }
    .swiper-fade .swiper-slide {
        pointer-events: none;
        transition-property: opacity;
    }
    .swiper-fade .swiper-slide .swiper-slide {
        pointer-events: none;
    }
    .swiper-fade .swiper-slide-active {
        pointer-events: auto;
    }
    .swiper-fade .swiper-slide-active .swiper-slide-active {
        pointer-events: auto;
    }
    
    // PAGINATION
   
    .swiper-pagination {
        position: absolute;
        text-align: center;
        transition: 300ms opacity;
        transform: translate3d(0, 0, 0);
        z-index: 10;
    }
    .swiper-pagination.swiper-pagination-hidden {
        opacity: 0;
    }
    .swiper-pagination-disabled > .swiper-pagination,
    .swiper-pagination.swiper-pagination-disabled {
        display: none !important;
    }
    /* Common Styles */
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal {
        bottom: var(--swiper-pagination-bottom, 8px);
        top: var(--swiper-pagination-top, auto);
        left: 0;
        width: 100%;
    }
    /* Bullets */
    .swiper-pagination-bullets-dynamic {
        overflow: hidden;
        font-size: 0;
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transform: scale(0.33);
        position: relative;
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
        transform: scale(1);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
        transform: scale(1);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
        transform: scale(0.66);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
        transform: scale(0.33);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
        transform: scale(0.66);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
        transform: scale(0.33);
    }
    .swiper-pagination-bullet {
        width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
        height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
        display: inline-block;
        border-radius: var(--swiper-pagination-bullet-border-radius, 50%);
        background: var(--swiper-pagination-bullet-inactive-color, #000);
        opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);
    }
    button.swiper-pagination-bullet {
        border: none;
        margin: 0;
        padding: 0;
        box-shadow: none;
        -webkit-appearance: none;
        appearance: none;
    }
    .swiper-pagination-clickable .swiper-pagination-bullet {
        cursor: pointer;
    }
    .swiper-pagination-bullet:only-child {
        display: none !important;
    }
    .swiper-pagination-bullet-active {
        opacity: var(--swiper-pagination-bullet-opacity, 1);
        background: var(--swiper-pagination-color, var(--swiper-theme-color));
    }
    .swiper-vertical > .swiper-pagination-bullets,
    .swiper-pagination-vertical.swiper-pagination-bullets {
        right: var(--swiper-pagination-right, 8px);
        left: var(--swiper-pagination-left, auto);
        top: 50%;
        transform: translate3d(0px, -50%, 0);
    }
    .swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;
        display: block;
    }
    .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
    .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
    }
    .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
    .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        display: inline-block;
        transition: 200ms transform,
        200ms top;
    }
    .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
        margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
    }
    .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
    .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
    }
    .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: 200ms transform,
        200ms left;
    }
    .swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
        transition: 200ms transform,
        200ms right;
    }
    /* Fraction */
    .swiper-pagination-fraction {
        color: var(--swiper-pagination-fraction-color, inherit);
    }
    /* Progress */
    .swiper-pagination-progressbar {
        background: var(--swiper-pagination-progressbar-bg-color, rgba(0, 0, 0, 0.25));
        position: absolute;
    }
    .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
        background: var(--swiper-pagination-color, var(--swiper-theme-color));
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        transform: scale(0);
        transform-origin: left top;
    }
    .swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
        transform-origin: right top;
    }
    .swiper-horizontal > .swiper-pagination-progressbar,
    .swiper-pagination-progressbar.swiper-pagination-horizontal,
    .swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
    .swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {
        width: 100%;
        height: var(--swiper-pagination-progressbar-size, 4px);
        left: 0;
        top: 0;
    }
    .swiper-vertical > .swiper-pagination-progressbar,
    .swiper-pagination-progressbar.swiper-pagination-vertical,
    .swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
    .swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {
        width: var(--swiper-pagination-progressbar-size, 4px);
        height: 100%;
        left: 0;
        top: 0;
    }
    .swiper-pagination-lock {
        display: none;
    }
    
    /**
        Styles for when a Block is in A carousel with pagination.  
        Using a media query for specificity override.
     */
    @media (min-width: 1px) {
        .swiper-slide .oui-block__button-over-image-bottom .oui-block__button {
            padding-bottom: 36px !important;;
        }
        .swiper-slide .oui-block__content-over-image-bottom:not(:has(.oui-block__button)) .oui-block__content {
            padding-bottom: 36px !important;
        }
    }
`

interface Props extends BoxProps{
    spaceBetween? : number;
    slidesPerView? : number;
    paginationColor?: string;
    autoPlay?: boolean;
}

const Carousel:React.FC<PropsWithChildren<Props>> = ({
     spaceBetween = 0,
     slidesPerView = 1,
     autoPlay = true,
     children,
     ...rest
}) => {
    return (
        <Container {...rest}>
            <Swiper
                modules={[EffectFade, Autoplay, Pagination]}
                spaceBetween={spaceBetween}
                slidesPerView={slidesPerView}
                effect="fade"
                pagination={{
                    clickable: true,
                }}
                autoplay={autoPlay ? {
                    delay: 3000,
                    disableOnInteraction: true,
                } : false}
            >
                {React.Children.map(children, (child:ReactNode) => <SwiperSlide>{child}</SwiperSlide>)}
            </Swiper>
        </Container>
    );
};

export default Carousel;